

import { db,auth,storage } from "./firebase";

import { addDoc, collection, deleteDoc, doc, getCountFromServer, getDoc, getDocs, updateDoc} from "firebase/firestore";
import { createUserWithEmailAndPassword, deleteUser, signInWithEmailAndPassword, signOut, updateEmail, updatePassword } from "firebase/auth";
import { deleteObject, getDownloadURL, ref, uploadBytes } from "firebase/storage";

import { v4 } from "uuid";


/**Gestion des Comptes utilisateurs */
export function CreateAccount(email,password) {
    createUserWithEmailAndPassword(auth,email,password)
    
}
export function SignIn (email,password) {
    signInWithEmailAndPassword(email,password)
}
export function SignOut() {
    signOut(auth)
    
}

export function DeleteUser(user) {
    deleteUser(user)
     
}
export function UpdateUserEmail(user,newEmail) {
    const current_user=user
    updateEmail(current_user,newEmail)
     
}
export function UpdateUserPassword(user,newPassword) {
    updatePassword(user,newPassword)
    
}

/**Gestion de document sur la database */

export async function getUser(collectionName,idDoc) {

    
    const DocRef=doc(db,collectionName,idDoc)
    try {
        const docSnap = await getDoc(DocRef);
        if(docSnap.exists()) {
            //setProduit(docSnap.data());
            //retourne la valeur du doc ici
        } else {
            //console.log("Document n'existe pas ")
            document.querySelector('#ErrorDial').showModal()
        }
    
    } catch(error) {
        console.log(error)
    }
   
    
}

/**Décompte des documents*/

export async function Doc_Counter (collectionName,getvalue) {
    const collectionRef=collection(db,collectionName)
    getCountFromServer(collectionRef).then((snapshot)=>{getvalue(snapshot.data().count)})


}



/**Gestion des produits,users,etc...*/

export async function AddDoc(collectionName,Doc) {

    const ProduitsDb=collection(db,collectionName)

     await addDoc(ProduitsDb,Doc)
    
}

export async function DeleteDoc (collectionName,id) {

    const userDoc = doc(db, collectionName, id);
    await deleteDoc(userDoc);


}
export async function UpdateDoc(Product_collection,id,data) {
    
    const DocRef=doc(db,Product_collection,id)
    await updateDoc(DocRef,data)
  
    
}

export async function GetProduct(Product_collection,id) {
    const DocRef=doc(db,Product_collection,id)

    try {
        const DocSnap=await getDoc(DocRef)
        if (DocSnap.exists()) {

            return DocSnap.data()
            
        }
        else {
            console.log("Produit n'existe pas")
        }

    } catch (error) {

        console.log(error)
        
    }

    
}

export async function GetDocs(collectionName) {
    const CollectionProd=collection(db,collectionName)

    const Data=await getDocs(CollectionProd);
    const Docs=Data.docs.map((doc)=>({...doc.data(),id:doc.id}))
    return Docs

    
}
export async function getUniqueDoc(collectionName,idDoc) {

    
    const DocRef=doc(db,collectionName,idDoc)
    try {
        const docSnap = await getDoc(DocRef);
        if(docSnap.exists()) {
            //setProduit(docSnap.data());
            //retourne la valeur du doc ici
            return (docSnap.data())
        } else {
            //console.log("Document n'existe pas ")
            //document.querySelector('#ErrorDial').showModal()
        }
    
    } catch(error) {
        console.log(error)
    }
   
    
}

/*Gestion du stockage et upload*/

export const uploadImageHandler = async (file, pathInStorage) => {
    const storageRef = ref(storage, pathInStorage);
  
    try {
      // Si tu veux supprimer l'ancien fichier avant (optionnel si le nom reste le même)
      await deleteObject(storageRef);
  
      // Upload du nouveau fichier
      const snapshot = await uploadBytes(storageRef, file);
  
      // Récupérer le lien de téléchargement
      const downloadURL = await getDownloadURL(snapshot.ref);
  
      //console.log("Image mise à jour avec succès !");
      //console.log("Lien de téléchargement :", downloadURL);
  
      return downloadURL;
    } catch (error) {
      console.error("Erreur lors de l'upload :", error);
      throw error;
    }
  }; 
export async function StoreImage(folder,imageFile,subFolder,DownloadUrl) {
   
    const imageRef = ref(storage, folder/subFolder.Nom/subFolder.Nom + v4());
        
    uploadBytes(imageRef, imageFile[0]).then((snapshot) => {
    getDownloadURL(snapshot.ref).then((url) => {
        DownloadUrl=url
                })})
    

}
export async function DeleteImage(folder,subFolder) {

    const imageRef = ref(storage, folder/subFolder.Nom/subFolder.Nom + v4());
    deleteObject(imageRef)
     

}




/*
function CRUD() {
  const [newName, setNewName] = useState("");
  const [newMarks, setNewMarks] = useState(0);

  const [users, setUsers] = useState([]);

 
  const usersCollectionRef = collection(db, "users");


  const UtilisateursCollect = collection(db, "Utilisateurs");

  const createUser = async () => {
    await addDoc(usersCollectionRef, { name: newName, marks: Number(newMarks) });
    getUsers();
  };

  const updateUser = async (id, marks) => {
    const userDoc = doc(db, "users", id);
    const newFields = { marks: marks + 1 };
    await updateDoc(userDoc, newFields);
    getUsers();
  };

  const deleteUser = async (id) => {
    const userDoc = doc(db, "users", id);
    await deleteDoc(userDoc);
    getUsers();
  };

  const getUsers = async () => {
    const data = await getDocs(usersCollectionRef);
    setUsers(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };



}
*/

